import { ProductType } from "../Types/ProductType";

export const getProductTypeFromPath = (pathname: string): ProductType | undefined => {
  const path = pathname.toLowerCase();
  if (path.includes('/develop/')) return ProductType.Develop;
  if (path.includes('/improve/')) return ProductType.Improve;
  if (path.includes('/evaluate/')) return ProductType.Evaluate;
  if (path.includes('/enquire/')) return ProductType.Enquire;

  return undefined;
};